/**
 * 如果Component不会被其他地方复用，没有必要增加文件
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import axios from 'axios';
import qs from 'qs';
import {Page} from '../components';
import { WKInfiniteScroll, WKOwnDialog } from '../components/wk'
import {Button, Dialog, CellHeader, Form, FormCell, CellBody, 
    Toast, CellFooter, Switch, Input, Label} from 'react-weui';
import {isLZWKAPP, renderMoney, isMoney, isIos, judgeAPPVersion } from '../utils';
import { goBack } from '../utils/connectApp'
import {NoneItem} from '../components/details'

import '../css/page/CouponListPage.css';
import NoCoupon from '../images/discount-no-source.png';
import SendButton from '../images/send-button.png';
import LineImg from '../images/discount-line.png';
import recommendImg from '../images/coupon/recommend.png'
import publicImg from '../images/coupon/public.png'

function getCouponScopeName(scope){
    switch(scope){
        case 'lecture':
            return '课程优惠券'
        case 'channel':
            return '专栏优惠券'
        case 'vip':
            return '会员优惠券'
        case 'liveroom':
            return '直播间通用券'
        default:
            return '优惠券'
    }
}


class CouponListItem extends Component {
    onDelete() {
        this.context.page.showConfirm('提示', '是否确定删除这个优惠券？删除之后未使用的用户不再可用，已使用的用户不受影响。', ()=>{
            this.props.onDeleteCoupon(this.props.coupon)
        })
    }

    onViewDetail() {
        this.props.onViewDetail(this.props.coupon)
    }

    onSend() {
        this.props.onSendCoupon(this.props.coupon)
    }

    isAvailable() {
        const {coupon} = this.props
        if(coupon.number_enabled && coupon.current >= coupon.number)
            return false
        if(coupon.deadline_enabled && Date.parse(coupon.deadline) < Date.now())
            return false
        return true
    }

    getCouponName (coupon) {
        const isOldName = ['专栏优惠券', '课程优惠券', '直播间通用券'].indexOf(coupon.coupon_name) > -1
        if (isOldName) {
            return coupon.scope_name
        } else {
            return `${coupon.scope_name}：${coupon.coupon_name}`
        }
    }

    render() {
        const {coupon} = this.props
        return (
            <div className="coupon-list-item">
                <div className="left">
                    <div className="price">
                        <span className="number">{coupon.price / 100}</span>
                        <span className="unit">元</span>
                    </div>
                    <div className="code">
                        优惠码 {coupon.code}
                    </div>
                    {
                        coupon.threshold_enabled && (
                            <div className="threshold">满{renderMoney(coupon.threshold_price)}元可用</div>
                        )
                    }
                    <img className="coupon-line" src={LineImg} alt=""/>
                    { coupon.show_enabled && <img className="public-icon" src={publicImg} alt=""/> }
                </div>
                <div className="right">
                    <div className="info">
                        <div className="title text-ellipsis">
                            {this.getCouponName(coupon)}
                        </div>
                        <div className="limits">
                            <p>数量：{coupon.number_enabled ? coupon.number : '不限'}</p>
                            <p>截止：{coupon.deadline_enabled ? coupon.deadline : '不限'}</p>
                        </div>
                        {this.isAvailable() &&
                        <div className="send" onClick={this.onSend.bind(this)}>
                            <img alt="" src={SendButton} />
                        </div>
                        }
                    </div>
                    <div className="bottom">
                        <div className="op">
                            <div className="op-left">
                                {coupon.current > 0 &&
                                <a onClick={this.onViewDetail.bind(this)}>{coupon.current}人已领取</a>
                                }
                            </div>
                            <div className="op-right">
                                <a onClick={this.onDelete.bind(this)}>删除</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


CouponListItem.contextTypes = {
    page: React.PropTypes.object,
};


class CouponAddDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            buttons: [{
                type: 'default',
                label: '取消',
                onClick: e => this.props.onCloseDialog()
            },{
                type: 'primary',
                label: '确定',
                onClick: this.onAdd.bind(this)
            }],
            price: 0,
            number_enabled: false,
            deadline_enabled: false,
            number: 1,
            deadline: null,
            title: '',
            show_enabled: false,
            threshold_enabled: false,
            threshold_price: '',
            isError1:false,//优惠金额提示
            isError2:false,//使用门槛提示
            isError3:false //优惠劵数量提示
        }
    }

    onAdd() {
        if(this.state.deadline_enabled){
            const deadline = this.state.deadline || ''
            const time = Date.parse(deadline.replace(/-/g,"/").replace(/T/g," "))

            // fix react-weui 年份位数bug(超过4位)
            const yearStr = deadline.substring(0, deadline.indexOf('-'));
            if (yearStr.length > 4) {
                this.setState({error: '请输入正确的截止时间'})
                return
            }

            if (!deadline) {
                console.log(deadline)
                this.setState({error: '请输入正确的截止时间'})
                return
            }
            if (time <= Date.now()) {
                console.log(deadline)
                this.setState({error: '截止时间应该大于当前时间'})
                return
            }
        }
        if(this.state.number_enabled && (!this.state.number || this.state.number <= 0 || !/^[1-9]([0-9]{1,3})*$/.test(this.state.number + ''))){
            this.setState({error: '请输入正确的数量'})
            return
        }
        if(!this.state.price){
            this.setState({error: '请输入优惠金额'})
            return
        }
        if (!isMoney(this.state.price)) {
            this.setState({error: '优惠金额不正确'})
            return
        }
        if(!this.state.title){
            this.setState({error: '请输入优惠券名称'})
            return
        }
        if(this.state.title.length > 10){
            this.setState({error: '优惠券名称字数不可超过10个'})
            return
        }
        if (this.state.threshold_enabled) {
            if (this.state.threshold_price <= 0 || this.state.threshold_price.trim() === '') {
                this.setState({error: '优惠券使用门槛必须大于0'})
                return
            }
            if (!isMoney(this.state.threshold_price)) {
              this.setState({error: '门槛金额不正确'})
              return
            }
        }
        
        this.props.onAddCoupon({
            price: this.state.price,
            title: this.state.title,
            show_enabled: this.state.show_enabled,
            coupon_type: 'stable',
            number_enabled: this.state.number_enabled,
            number: this.state.number,
            deadline_enabled: this.state.deadline_enabled,
            deadline: this.state.deadline && this.state.deadline.replace('T', ' '),
            threshold_enabled: this.state.threshold_enabled,
            threshold_price: (this.state.threshold_price * 100).toFixed(),
        })
    }

    scrollSuit (limit = 35, target = 300) {
        setTimeout(() => {
            // if (this.$formBody.scrollTop <= limit) {
                this.$formBody.scrollTo({ top: target, left: 0, behavior: 'smooth' })
            // }
        }, 300)
        
    }

    onChangeEnabled (e, field) {
        this.setState({[field]: e.target.checked})
        this.scrollSuit()
    }
    
    //封装一个输入判断
    onInputLimit(e,maxValue,type){
      if(!e.target.value.match(/[^/d]/g,'')){               //不是数字，重置为空
        e.target.value = ''
        return
      }
      //优惠金额
      if(type === 'discount'){                        
        this.setState({isError1:false})
        if(e.target.value < 0){
          e.target.value = 0
          this.setState({isError1:true})
        }else if (e.target.value > maxValue){
          e.target.value = maxValue
        }else if(isMoney(e.target.value)){                     //判断是否是正确的金钱
        }else{
          this.setState({isError1:true})
        }
      //使用金额
      }else if(type === 'limit'){
        this.setState({isError2:false})
        if(e.target.value < 0){
          e.target.value = 0
          this.setState({isError2:false})
        }else if (e.target.value > maxValue){
          e.target.value = maxValue
        }else if(isMoney(e.target.value)){                     //判断是否是正确的金钱
        }else{
          this.setState({isError2:true})
        }
      }
      
    }

    //数量输入框判断
    onInputNumber(e,maxValue,type){
      if(!e.target.value.match(/[^/d]/g,'')){               //不是数字，重置为空
        e.target.value = ''
        return
      }
      if(type === 'number'){
        this.setState({isError3:false})
        if(e.target.value < 0){
          e.target.value = 1
        }else if (e.target.value > maxValue){
          e.target.value = maxValue
        }else if((e.target.value <= 0 || !/^[1-9]([0-9]{1,3})*$/.test(e.target.value + ''))){  //数量小于1，开头为0，或者是小数点都是达不到条件
            this.setState({isError3:true})
          }
        
      }
    }

    render() {
        const {addToScope} = this.props
        const {number_enabled, deadline_enabled, error} = this.state
        return <div className="coupon-add-dialog">
            <Dialog type="ios" title={"添加" + getCouponScopeName(addToScope)}
                    buttons={this.state.buttons}
                    show={true}
                    >
                <div className="form-body" ref={ r => this.$formBody = r}>
                    <div className="price">
                        <div className="label">
                            优惠券名称
                        </div>
                        <div className="input">
                            <input type="text" placeholder="优惠券名称" onChange={e=>this.setState({title: e.target.value})} />
                        </div>
                    </div>

                    <div className="price">
                        <div className="label">
                            优惠金额
                        </div>
                        <div className="input">
                            <input type="number"  placeholder="价格（元）"  max="100000"
                            onChange={e => this.setState({price: e.target.value})}
                            onInput={(e) => this.onInputLimit(e,100000,'discount')} 
                            style={{color:this.state.isError1 ? '#ea1818':''}}
                            />
                            
                        </div>
                        {/* min="0.01" */}
                    </div>

                    <Form>
                        <FormCell switch>
                            <CellBody className='public-on-detail'>
                                <span>在详情页公开领券</span>
                                <div className="icon" style={{display: 'none'}}><img src={recommendImg} alt=""/></div>
                            </CellBody>
                            <CellFooter>
                                <Switch onChange={e=> {this.setState({show_enabled: e.target.checked})}} />
                            </CellFooter>
                        </FormCell>
                        {
                            addToScope === 'liveroom'  && (
                                <FormCell switch>
                                    <CellBody>设置使用门槛 </CellBody>
                                    <CellFooter>
                                        <Switch onChange={e=> this.onChangeEnabled(e, 'threshold_enabled')} />
                                    </CellFooter>
                                </FormCell>
                            )
                        }
                        {
                            addToScope === 'liveroom' && this.state.threshold_enabled && (
                                <FormCell className="value">
                                    <CellHeader>
                                        <Label className='color999'>金额满</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            maxLength="5"
                                            type="number" 
                                            placeholder="请输入金额" 
                                            onChange={e => this.setState({threshold_price: e.target.value})}
                                            value={this.state.threshold_price}
                                            onInput={(e) => {this.onInputLimit(e,10000,'limit')}}
                                            style={{color:this.state.isError2 ? '#ea1818':''}}
                                        />
                                    </CellBody>
                                </FormCell>
                            )
                        }
                        <FormCell switch>
                            <CellBody>设置优惠券数量</CellBody>
                            <CellFooter>
                                <Switch onChange={e=> this.onChangeEnabled(e, 'number_enabled')} />
                            </CellFooter>
                        </FormCell>
                        {number_enabled &&
                        <FormCell className="value">
                            <CellHeader>
                                <Label className='color999'>数量</Label>
                            </CellHeader>
                            <CellBody>
                                <Input type="number" className='amount' placeholder="请输入数量" 
                                  onChange={e=>this.setState({number: e.target.value})} 
                                  onInput={(e) => {this.onInputNumber(e,5000,'number')}}
                                  style={{color:this.state.isError3 ? '#ea1818':''}}
                                />
                            </CellBody>
                        </FormCell>
                        }
                    </Form>
                    <Form>
                        <FormCell switch>
                            <CellBody>设置截止时间</CellBody>
                            <CellFooter>
                                <Switch onChange={e => this.onChangeEnabled(e, 'deadline_enabled')} />
                            </CellFooter>
                        </FormCell>
                        {deadline_enabled &&
                        <FormCell className="value time-value">
                            <CellHeader>
                                <Label className='color999'>截止时间</Label>
                            </CellHeader>
                            <CellBody>
                                <Input style={{right: (window.platform === 'pc' && !isLZWKAPP()) ? '0' : '-100px'}} type="datetime-local" defaultValue="" placeholder="请输入截止时间"
                                    onChange={e=>this.setState({deadline: e.target.value})} />
                            </CellBody>
                        </FormCell>
                        }
                    </Form>
                </div>
                {error ?
                    <div className="error">
                        {error}
                    </div>
                    :
                    <div className="text-muted">
                        提示：<br />批量创建一对一发放的优惠券请登录讲师管理后台操作
                    </div>
                }
            </Dialog>
        </div>
    }
}


class CouponNoSource extends Component {
    render() {
        return (
            <NoneItem
                img="https://static-1253442168.image.myqcloud.com/picture/6163375_5608ddb36855c66d6e07d4743bde1b9f.jpg"
                text="暂无优惠券"
            />
        )
    }
}


class CouponMenuBar extends Component {
    getBtnText (scope) {
        switch (scope) {
            case 'liveroom':
                return '直播间通用券'
            default:
                return '优惠券'
        }
    }
    render() {
        return (
            <div className="wk-bottom-bar">
                <div className="wk-sexy-padding">
                    <Button onClick={e => this.props.createCoupon()}>创建{this.getBtnText(this.props.scope)}</Button>
                </div>
            </div>
        )
    }
}


class CouponListPage extends Component {
    constructor() {
        super()
        this.state = {
            coupons: [],
            initialized: false,
            offset: 0,
            hasMore: true,
            showAddDialog: false,
            showLoading: false,
            isPending: false,
        }
    }

    componentDidMount() {
        const {query} = this.props.location
        this.setState({
            scope: query.scope,
            lecture_id: query.lecture_id,
            channel_id: query.channel_id
        })
        this.reload()
        if (query.scope === 'liveroom') {
            this.setLiveroomName()
        }else{
            document.title = '优惠券'
        }

        //风控
        this.page.showFengKongTip()
    }

    setLiveroomName () {
        axios.get(`/api/liveroom/${this.props.params.liveroom_id}/info`)
            .then(res => {
                if (res.data.code === 0) {
                    document.title = res.data.data.liveroom.name
                }
            })
    }

    reload(isForce = false) {
        const {liveroom_id} = this.props.params
        const {query} = this.props.location
        const params = {
            ...query,
            offset: isForce ? 0 : this.state.offset,
        }
        this.setState({ isPending: true })
        axios.get(`/api/liveroom/${liveroom_id}/coupon/list`, {params: params}).then((res) => {
            if (res.data.code === 0) {
                const {data} = res.data
                this.setState({
                    initialized: true,
                    offset: data.next_offset,
                    hasMore: data.has_more,
                    coupons: isForce ? data.coupons : this.state.coupons.concat(data.coupons),
                    isPending: false,
                })
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.status === 403 ? '对不起 您没有权限' : res.data.msg
                    }
                })
            }
        }).catch((error) => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: error && error.response && error.response.status === 403 ? '对不起 您没有权限' : '读取错误：' + error
                }
            })
        })
    }

    onAddCoupon(coupon){
        const {liveroom_id} = this.props.params
        coupon.scope = this.state.scope
        coupon.lecture = this.state.lecture_id
        coupon.channel = this.state.channel_id

        this.setState({showLoading: true, showAddDialog: false})
        axios.post(`/api/liveroom/${liveroom_id}/coupon/add`, qs.stringify(coupon)).then((res) => {
            this.setState({showLoading: false})
            if(res.data.code === 0){
                this.reload(true)
            }else{
                const msg = res.data.msg
                                .replace('price', '优惠金额')
                                .replace('number', '领取人数')
                                .replace('优惠券数量','')
                                .replace('__all__', '优惠券数量')
                this.page.showConfirm('温馨提示', <span>{msg}</span>)
            }
        })
    }

    onDeleteCoupon(coupon){
        const {liveroom_id} = this.props.params
        this.setState({showLoading: true})
        axios.post(`/api/liveroom/${liveroom_id}/coupon/delete`, qs.stringify({coupon_id: coupon.id})).then((res) => {
            this.setState({showLoading: false})
            if(res.data.code === 0){
                this.reload(true)
            }else{
                this.page.showConfirm('温馨提示', <span>{res.data.msg}</span>)
            }
        })
    }

    onSendCoupon(coupon){
        const {liveroom_id} = this.props.params
        window.location = `/liveroom/${liveroom_id}/coupon/${coupon.id}/share`
    }

    onViewDetail(coupon){
        const {liveroom_id} = this.props.params
        location.assign(`/liveroom/${liveroom_id}/coupon/${coupon.id}/receiver/list`)
    }

    showCreateCoupon(){
        this.setState({
            showAddDialog: true
        })
    }

    render() {
        // ios审核屏蔽
        // if (isLZWKAPP() && isIos() && judgeAPPVersion(420)) {
        //     return (
        //         <WKOwnDialog type="ios" title='' buttons={[
        //             { label: '确定', onClick: () => goBack() }
        //         ]} show={true}>
        //             <span>优惠券功能正在改版中</span>
        //             <br />
        //             <span>如需使用，请前往“荔枝微课”公众号</span>
        //         </WKOwnDialog>
        //     )
        // }
        const {coupons} = this.state
        return (
            <Page parent={this}>
                <Toast icon="loading" show={this.state.showLoading}>
                    请稍后
                </Toast>
                {this.state.showAddDialog &&
                <CouponAddDialog addToScope={this.state.scope}
                    onCloseDialog={e => this.setState({showAddDialog: false})}
                    onAddCoupon={this.onAddCoupon.bind(this)} />
                }
                <div className="coupon-list" style={{paddingLeft: coupons.length > 0 ? '' : '0'}}>
                    {coupons.length > 0 ?
                        coupons.map((coupon) => (
                            <CouponListItem key={coupon.id} coupon={coupon}
                                onViewDetail={this.onViewDetail.bind(this)}
                                onDeleteCoupon={this.onDeleteCoupon.bind(this)} 
                                onSendCoupon={this.onSendCoupon.bind(this)}
                                />
                        ))
                        :
                        <CouponNoSource />
                    }
                </div>
                <CouponMenuBar scope={this.state.scope} createCoupon={this.showCreateCoupon.bind(this)} />
                <WKInfiniteScroll 
                    onTouchBottom={() => this.reload()} // 到达底部执行的方法
                    isStop={this.state.isPending} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                    isKill={!this.state.hasMore} // 不再监听滚动，一般是传has_more 
                    isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                />
            </Page>
        )
    }
}

export default connect((state) => ({
}))(CouponListPage)



// WEBPACK FOOTER //
// ./src/pages/CouponListPage.js